import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";

const experiences = [
  {
    year: "2024-Current",
    title: "Software Engineer",
    company: "7-Eleven (via Resolve Tech Solutions)",
    description:
      "Working on 7Now platforms team to develop infrastructures/platforms to run the 7-Eleven's web services. Optimize the performance of the web services and improve the overall performance of the 7-Eleven's web services.",
  },
  {
    year: "2022-2023",
    title: "Masters of Computer Science",
    company: "Maharishi University",
    description:
      "Attended a master's degree in computer science and engineering from Maharishi University studying the intricacies of software development, programming languages and enterprise software development.",
  },
  {
    year: "2021",
    title: "Software Engineer",
    company: "HLE Nepal",
    description:
      "Designed, developed, and maintained the main web app of the leading mortgage brokerage firm of Australia Using Node.js, PHP, Laravel using AWS cloud infrastructure.",
  },
  {
    year: "2019-2021",
    title: "Software Engineer",
    company: "Grepsr",
    description:
      "Developed plugins using PHP, Node and Java for a data collection framework enabling customers to acquire any data from the internet or other sources",
  },
  {
    year: "2015-2019",
    title: "Associate Software Engineer",
    company: "GrowByData Solutions",
    description:
      "Developed, maintained and optimized a e-commerce app, conversion on demand, which helped to increase e-commerce vendors sales significantly.",
  },
  {
    year: "2014-2015",
    title: "Associate Software Engineer",
    company: "SAM Audio Video",
    description:
      "Contributed to the development of a audio/video library system, gaining hands-on experience in Java",
  },
];


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container className="experience-content">
          <Row>
            <Col md={12} className="experience-header">
            <h1 className="project-heading">
          My <strong className="purple">Experience </strong>
        </h1>
            </Col>
          </Row>
          <Row>
            <Col md={10}>
              <div className="timeline">
                {experiences.map((exp, index) => (
                  <div className="timeline-item" key={index}>
                    <div className="timeline-date purple">
                      <h3>{exp.year}</h3>
                    </div>
                    <div className="timeline-content">
                      <h4><strong>{exp.company}</strong></h4>
                      <h5>{exp.title}</h5>
                      <hr/>
                      <p>{exp.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      {/* <Container>
        <h1 className="project-heading">
          My <strong className="purple">Experience </strong>
        </h1>
        { <p style={{ color: "white" }}>
          Here are  I've worked on recently.
        </p> }
        { <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Chatify"
              description="Personal Chat Room or Workspace to share resources and hangout with friends build with react.js, Material-UI, and Firebase. Have features which allows user for realtime messaging, image sharing as well as supports reactions on messages."
              ghLink="https://github.com/soumyajit4419/Chatify"
              demoLink="https://chatify-49.web.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Bits-0f-C0de"
              description="My personal blog page build with Next.js and Tailwind Css which takes the content from makdown files and renders it using Next.js. Supports dark mode and easy to write blogs using markdown."
              ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Editor.io"
              description="Online code and markdown editor build with react.js. Online Editor which supports html, css, and js code with instant view of website. Online markdown editor for building README file which supports GFM, Custom Html tags with toolbar and instant preview.Both the editor supports auto save of work using Local Storage"
              ghLink="https://github.com/soumyajit4419/Editor.io"
              demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Plant AI"
              description="Used the plant disease dataset from Kaggle and trained a image classifer model using 'PyTorch' framework using CNN and Transfer Learning with 38 classes of various plant leaves. The model was successfully able to detect diseased and healthy leaves of 14 unique plants. I was able to achieve an accuracy of 98% by using Resnet34 pretrained model."
              ghLink="https://github.com/soumyajit4419/Plant_AI"
              demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Ai For Social Good"
              description="Using 'Natural Launguage Processing' for the detection of suicide-related posts and user's suicide ideation in cyberspace  and thus helping in sucide prevention."
              ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col>
        </Row> }


        
      </Container> */}
    </Container>
  );
}

export default Projects;
